import React from 'react'
import { P } from '../components/UI'

const Page404 = () => {
	return <P>404 Page not found</P>
}
Page404.propTypes = {}
export default Page404
